export default __webpack_public_path__ + "static/media/bloodyhack3.dbff522f.png";